import { render, staticRenderFns } from "./PatientBoard.vue?vue&type=template&id=05e37b6b&scoped=true&lang=pug"
import script from "./PatientBoard.vue?vue&type=script&lang=js"
export * from "./PatientBoard.vue?vue&type=script&lang=js"
import style0 from "./PatientBoard.vue?vue&type=style&index=0&id=05e37b6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e37b6b",
  null
  
)

export default component.exports